module.exports = function(str) {
  return (str + "")
    .toString()                     // catch numbers that slip through
    .toLowerCase()
    .trim()                         // trim out extra whitespace from beginning/end
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
};